import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import BlankAsDropdownSettingsDialog from "@/components/questions/fillInTheBlanks/BlankAsDropdownSettingsDialog.vue";
import BlankAsTextSettingsDialog from "@/components/questions/fillInTheBlanks/BlankAsTextSettingsDialog.vue";
import { BlankType } from "@/models/blanksInput.model";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import quizUtils from "@/util/quizUtils";
/**
 * Composant d'input avec blanks éditables
 * Permet d'ajouter des espaces réservés (blanks) dans un texte éditable
 */
let BlanksInput = class BlanksInput extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "blanksData", void 0);
    /**
     * Liste des blanks présents dans l'éditeur
     */
    _defineProperty(this, "realtimeBlanksData", {
      text: '',
      blanks: []
    });
    _defineProperty(this, "activeBlank", null);
    _defineProperty(this, "displayBlankAsTextSettingsDialog", false);
    _defineProperty(this, "displayBlankAsDropdownSettingsDialog", false);
    _defineProperty(this, "displayBlankDeletionDialog", false);
    /**
     * Sauvegarde de la dernière position du curseur
     */
    _defineProperty(this, "lastSelection", null);
    /**
     * Compteur pour générer des IDs uniques pour les blanks
     */
    _defineProperty(this, "blankIdCounter", 0);
    /**
     * Contenu HTML initial généré à partir des props
     */
    _defineProperty(this, "initialContent", '');
    /**
     * Zero width space character
     */
    _defineProperty(this, "zeroWidthSpaceChar", '\u200B');
    /**
     *
     * space character
     */
    _defineProperty(this, "spaceCharacter", '\u00A0');
  }
  blanksDataSet() {
    this.initEditor();
  }
  /**
   * Contenu HTML formaté à afficher dans l'éditeur
   */
  get formattedContent() {
    return this.initialContent;
  }
  /**
   * Hook de montage du composant
   */
  mounted() {
    this.initEditor();
  }
  /**
   * initialize editor
   * @private
   */
  initEditor() {
    this.realtimeBlanksData = structuredClone(this.blanksData);
    // Initialiser le contenu avant le montage
    this.initialContent = this.generateInitialContent();
    this.$nextTick(() => {
      this.renumberBlanks();
      this.ensureEditableSpace();
    });
  }
  /**
   * Génère le contenu HTML initial à partir du texte et des blanks
   * @returns Le HTML formaté avec les blanks
   */
  generateInitialContent() {
    if (!this.realtimeBlanksData.text?.trim()?.length) {
      return '';
    }
    let htmlContent = this.realtimeBlanksData.text;
    htmlContent = htmlContent.replace(/\n+/g, '<br>');
    const replacements = [];
    for (let i = 0; i < this.blanksData.blanks.length; i++) {
      const pattern = `[?${i + 1}]`;
      if (htmlContent.includes(pattern)) {
        replacements.push({
          pattern,
          index: i
        });
      }
    }
    // Trier par longueur de pattern décroissante
    replacements.sort((a, b) => b.pattern.length - a.pattern.length);
    // Effectuer les remplacements
    replacements.forEach(({
      pattern,
      index
    }) => {
      const blankHtml = this.createBlankHtml(this.realtimeBlanksData.blanks[index]);
      this.realtimeBlanksData.blanks[index].htmlId = blankHtml.dataset.id;
      htmlContent = htmlContent.replace(new RegExp(pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), blankHtml.outerHTML + this.spaceCharacter);
    });
    return htmlContent;
  }
  addTextBlank() {
    this.activeBlank = null;
    this.displayBlankAsTextSettingsDialog = true;
  }
  addDropdownBlank() {
    this.activeBlank = null;
    this.displayBlankAsDropdownSettingsDialog = true;
  }
  /**
   * Gère les clics dans l'éditeur
   * @param event - L'événement de clic
   */
  handleEditorClick(event) {
    const target = event.target;
    // Gestion du clic sur la croix de suppression
    if (target.classList.contains('blank-delete') || target.classList.contains('blank-delete-icon')) {
      event.preventDefault();
      event.stopPropagation();
      const blankTag = target.closest('.blank-tag');
      const blankToDelete = this.realtimeBlanksData.blanks.find(blank => blank.htmlId === blankTag.dataset.id);
      if (blankToDelete) {
        this.deleteBlank(blankToDelete);
      }
      return;
    }
    // Gestion du clic sur le blank lui-même
    if (target.classList.contains('blank-answer-overview') || target.classList.contains('blank-tag')) {
      event.preventDefault();
      const blankTag = target.classList.contains('blank-tag') ? target : target.closest('.blank-tag');
      const blankToEdit = this.realtimeBlanksData.blanks.find(blank => blank.htmlId === blankTag.dataset.id);
      if (blankToEdit) {
        this.triggerBlankEdit(blankToEdit);
      }
    }
  }
  /**
   * Gère le collage de contenu dans l'éditeur
   * Nettoie tout le HTML et ne garde que le texte brut
   * @param event - L'événement de collage
   */
  handlePaste(event) {
    // Empêcher le comportement par défaut
    event.preventDefault();
    event.stopPropagation();
    // Récupérer le texte brut du presse-papier
    const clipboardData = event.clipboardData || window.clipboardData;
    if (!clipboardData) return;
    // Obtenir uniquement le texte brut, sans formatage
    const plainText = clipboardData.getData('text/plain');
    // Nettoyer le texte de tout caractère de contrôle indésirable
    const cleanedText = this.cleanText(plainText);
    // Insérer le texte nettoyé à la position du curseur
    this.insertTextAtCursor(cleanedText);
    this.renumberBlanks();
  }
  /**
   * Nettoie le texte de tout caractère indésirable
   * @param text - Le texte à nettoyer
   * @returns Le texte nettoyé
   */
  cleanText(text) {
    // Supprimer les caractères de contrôle sauf les retours à la ligne
    let cleaned = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '');
    // Remplacer les multiples espaces par un seul
    cleaned = cleaned.replace(/\s+/g, ' ');
    // Remplacer les retours à la ligne multiples par un seul
    cleaned = cleaned.replace(/\n+/g, ' ');
    // Supprimer les espaces en début et fin
    cleaned = cleaned.trim();
    return cleaned;
  }
  /**
   * Insère du texte brut à la position actuelle du curseur
   * @param text - Le texte à insérer
   */
  insertTextAtCursor(text) {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;
    const range = selection.getRangeAt(0);
    // Supprimer le contenu sélectionné s'il y en a
    range.deleteContents();
    // Créer un nœud de texte avec le contenu nettoyé
    const textNode = document.createTextNode(text);
    // Insérer le texte
    range.insertNode(textNode);
    // Placer le curseur après le texte inséré
    range.setStartAfter(textNode);
    range.setEndAfter(textNode);
    range.collapse(false);
    // Mettre à jour la sélection
    selection.removeAllRanges();
    selection.addRange(range);
    // Sauvegarder la nouvelle position
    this.saveSelection();
  }
  /**
   * Gère la perte de focus de l'éditeur.
   * si la perte de focus ne va pas sur le bouton d'ajout d'un blanc
   * ou vers les modales d'édition/suppression d'un blanc, alors on sauvegare les texte.
   * @param event - L'événement de blur
   */
  onBlur(event) {
    const addButton = this.$refs.addBlankRef;
    if (event.relatedTarget !== addButton) {
      setTimeout(() => {
        const editor = this.$refs.editorRef;
        if (!this.activeBlank && document.activeElement !== editor && document.activeElement !== addButton) {
          if (!this.realtimeBlanksData.blanks.length) {
            WElMessage.showErrorMessage(this.$t('chapter.question.fillInTheBlanks.errorAlert.missingBlank'));
            return;
          }
          this.emitFormattedContent();
        }
      }, 100);
    }
  }
  /**
   * Gère les événements clavier dans l'éditeur
   * @param event - L'événement clavier
   */
  onKeyDown(event) {
    const selection = window.getSelection();
    if (!selection) return;
    const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
    // Gestion de la navigation avec flèche gauche
    if (event.key === 'ArrowLeft') {
      this.handleArrowLeft(event, selection, range);
    }
    // Gestion de la navigation avec flèche droite
    if (event.key === 'ArrowRight') {
      this.handleArrowRight(event, selection, range);
    }
    // Gère la touche Enter dans l'éditeur, pour inserer un br
    if (event.key === "Enter") {
      this.handleEnter(event);
    }
    // Nettoyer les <br> générés automatiquement entre deux champs lorsqu'il n'y a plus d'espace entre eux
    if (event.key === 'Backspace' || event.key === 'Delete') {
      this.handleBackspaceOrDelete(event, range);
    }
  }
  /**
   * Gère la touche Flèche Gauche pour empêcher le caret d'entrer dans un .blank-tag
   * et repositionne le caret juste avant ce blank de manière logique.
   *
   * @param event - L'événement clavier
   * @param selection - La sélection courante
   * @param range - Le range de la sélection
   */
  handleArrowLeft(event, selection, range) {
    if (!range) return;
    const container = range.startContainer; // Nœud où se trouve le caret
    const offset = range.startOffset;
    // Cas: caret au tout début du container ET l’élément précédent est un .blank-tag
    const previousSibling = container.previousSibling;
    if (offset === 0 && previousSibling?.classList?.contains('blank-tag')) {
      event.preventDefault(); // Empêche le déplacement par défaut du caret dans le blank
      const blank = previousSibling;
      // S'il existe un nœud avant le blank, on repositionne le caret par rapport à lui
      if (blank.previousSibling) {
        const newRange = document.createRange();
        const prevNode = blank.previousSibling;
        if (prevNode.nodeType === Node.TEXT_NODE) {
          // Si le précédent est un texte: positionner le caret à la fin de ce texte
          const textNode = prevNode;
          newRange.setStart(textNode, textNode.textContent?.length || 0);
          newRange.collapse(true);
        } else {
          // Sinon: positionner le caret juste avant le blank (au niveau du parent)
          newRange.setStartBefore(blank);
          newRange.collapse(true);
        }
        // Appliquer la nouvelle sélection
        selection.removeAllRanges();
        selection.addRange(newRange);
      } else {
        // Aucun nœud avant le blank: on est au tout début de l'éditeur
        const newRange = document.createRange();
        const editor = this.$refs.editorRef;
        // Place le caret au tout début de l'éditeur
        newRange.setStart(editor, 0);
        newRange.collapse(true);
        selection.removeAllRanges();
        selection.addRange(newRange);
      }
    }
  }
  /**
   * Gère la touche Flèche Droite pour empêcher le caret d'entrer dans un .blank-tag
   * et repositionne le caret juste après ce blank de manière logique.
   * @param event - L'événement clavier
   * @param selection - La sélection courante
   * @param range - Le range de la sélection
   */
  handleArrowRight(event, selection, range) {
    if (!range) return;
    const container = range.startContainer; // Nœud où se trouve le caret
    const offset = range.startOffset;
    // Déterminer le nœud "suivant" par rapport à la position actuelle du caret
    let nextNode = null;
    if (container.nodeType === Node.TEXT_NODE) {
      // Si on est dans un texte: le nœud suivant est le sibling suivant
      // uniquement si le caret est à la fin du texte
      const textNode = container;
      if (offset === textNode.textContent?.length) {
        nextNode = container.nextSibling;
      }
    } else {
      // Si on est dans un élément: l'enfant à l'index
      // `offset` est le "prochain" nœud logique
      const element = container;
      nextNode = element.childNodes[offset] || null;
    }
    // Si le nœud suivant est un .blank-tag, on empêche le caret d'entrer dedans
    const nextElement = nextNode;
    if (nextElement?.classList?.contains('blank-tag')) {
      event.preventDefault();
      const blank = nextElement;
      // On souhaite positionner le caret juste APRÈS le blank
      if (blank.nextSibling) {
        const newRange = document.createRange();
        const nextTextNode = blank.nextSibling;
        if (nextTextNode.nodeType === Node.TEXT_NODE) {
          // S'il y a un texte juste après: placer le caret au début de ce texte
          newRange.setStart(nextTextNode, 0);
          newRange.collapse(true);
        } else {
          // Sinon: placer le caret juste après le blank (au niveau du parent)
          newRange.setStartAfter(blank);
          newRange.collapse(true);
        }
        // Appliquer la nouvelle sélection
        selection.removeAllRanges();
        selection.addRange(newRange);
      }
    }
  }
  /**
   * Gère la touche Enter dans l'éditeur:
   * - Empêche le comportement par défaut (qui peut varier selon les navigateurs).
   * - Insère un <br> suivi d’un caractère espace de largeur zéro pour stabiliser le caret.
   * - Replace le caret juste après le <br>.
   */
  handleEnter(event) {
    // On bloque le comportement natif d'Enter (insertion de div/p/br selon le navigateur)
    event.preventDefault();
    const selection = window.getSelection();
    if (!selection || !selection.rangeCount) return;
    const range = selection.getRangeAt(0);
    // Crée un caractère "Zero-Width Space" (ZWSP) pour assurer un point d’ancrage caret après le <br>
    // Sans ce caractère, certains navigateurs laissent le caret dans un état instable après un <br>
    const zeroWidthSpace = document.createTextNode(this.zeroWidthSpaceChar);
    // Crée un saut de ligne visuel via <br>
    const br = document.createElement("br");
    range.insertNode(zeroWidthSpace);
    range.insertNode(br);
    // Replace la range (caret) juste après le <br>
    range.setStartAfter(br);
    range.setEndAfter(br);
    // Applique la nouvelle sélection (caret positionné après le <br>)
    selection.removeAllRanges();
    selection.addRange(range);
  }
  /**
   * Intercepte Backspace/Delete pour protéger les .blank-tag et
   * normalise les <br> qui suivent immédiatement un blank après l'action du navigateur.
   *
   * - Pendant l'événement:
   *   - Si le caret est au tout début d'un nœud texte et qu'il y a un .blank-tag juste avant,
   *     on empêche la suppression (preventDefault).
   * - Après l'événement (via setTimeout 0):
   *   - Parcourt tous les .blank-tag et remplace les <br> immédiatement suivants
   *     par un nœud texte (this.spaceCharacter), afin d'éviter des sauts de ligne persistants
   *     et stabiliser la navigation/caret.
   */
  handleBackspaceOrDelete(event, range) {
    if (!range) return;
    const editor = this.$refs.editorRef;
    const blanks = editor.querySelectorAll('.blank-tag');
    if (!range.collapsed) {
      const container = range.cloneContents();
      const temp = document.createElement('div');
      temp.appendChild(container);
      if (temp.querySelector('.blank-tag')) {
        WElMessage.showErrorMessage(this.$t('chapter.question.fillInTheBlanks.errorAlert.textDeleteIncludingBlank'));
        event.preventDefault();
      }
    } else {
      // N'agir que si le caret est "collapsed" (pas de sélection étendue)
      const {
        startContainer,
        startOffset
      } = range;
      // Cas: caret au début d'un nœud texte et un .blank-tag est juste avant
      // → Backspace supprimerait le blank → on bloque
      if (startContainer.nodeType === Node.TEXT_NODE && startOffset === 0) {
        const prevNode = startContainer.previousSibling;
        if (prevNode instanceof HTMLElement && prevNode.classList.contains('blank-tag')) {
          event.preventDefault();
        }
      }
    }
    // Laisser le navigateur terminer la mutation DOM (si non bloquée) puis nettoyer
    setTimeout(() => {
      blanks.forEach(blank => {
        // Parcourt les siblings qui suivent immédiatement le blank
        // et remplace les <br> par un espace (this.spaceCharacter)
        // pour éviter des sauts de ligne "collés" aux blanks qui perturbent le caret.
        let next = blank.nextSibling;
        while (next && next.nodeName === 'BR') {
          const toRemove = next;
          next = next.nextSibling;
          const space = document.createTextNode(this.spaceCharacter);
          // Remplace le <br> par un texte espace
          toRemove.replaceWith(space);
        }
      });
      this.$nextTick(() => {
        this.renumberBlanks();
        this.ensureEditableSpace();
      });
    }, 0);
  }
  /**
   * Renumérote tous les blanks de l'éditeur et met à jour leurs IDs
   */
  renumberBlanks() {
    const editor = this.$refs.editorRef;
    if (!editor) return;
    const tags = editor.querySelectorAll('.blank-tag');
    const newBlanks = [];
    tags.forEach((tag, index) => {
      const relatedBlankData = this.realtimeBlanksData.blanks.find(blank => blank.htmlId === tag.dataset.id);
      if (relatedBlankData) {
        const textElement = tag.querySelector('.blank-answer-overview');
        // Mettre à jour le texte visible
        if (textElement) {
          textElement.innerHTML = this.getBlankAnswerOverview(relatedBlankData);
        }
        const newPosition = index + 1;
        // Mettre à jour l'ID pour refléter le nouveau numéro
        const newId = `blank_${newPosition}`;
        tag.dataset.id = newId;
        newBlanks.push({
          ...relatedBlankData,
          htmlId: newId,
          position: newPosition
        });
      }
    });
    this.realtimeBlanksData.blanks = newBlanks;
    // Mettre à jour le compteur pour qu'il soit cohérent
    // avec le nombre de blanks existants
    this.blankIdCounter = tags.length;
  }
  /**
   * Sauvegarde la position actuelle du curseur
   */
  saveSelection() {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;
    const range = selection.getRangeAt(0);
    this.lastSelection = {
      startContainer: range.startContainer,
      startOffset: range.startOffset,
      endContainer: range.endContainer,
      endOffset: range.endOffset
    };
  }
  /**
   * Restaure la position sauvegardée du curseur
   */
  restoreSelection() {
    if (!this.lastSelection) return;
    const selection = window.getSelection();
    if (!selection) return;
    const range = document.createRange();
    try {
      range.setStart(this.lastSelection.startContainer, this.lastSelection.startOffset);
      range.setEnd(this.lastSelection.endContainer, this.lastSelection.endOffset);
      selection.removeAllRanges();
      selection.addRange(range);
    } catch (error) {
      // En cas d'erreur, placer le curseur à la fin
      const editor = this.$refs.editorRef;
      range.selectNodeContents(editor);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
  /**
   * Ajoute un blank à la position du curseur
   */
  addBlankAtCursor(blankData) {
    const editor = this.$refs.editorRef;
    editor.focus();
    this.restoreSelection();
    this.insertBlank(blankData);
  }
  /**
   * Insère un nouveau blank dans l'éditeur
   */
  insertBlank(blankData) {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;
    const range = selection.getRangeAt(0);
    // Créer l'élément blank avec un ID temporaire
    const span = this.createBlankHtml(blankData);
    blankData.htmlId = span.dataset.id;
    this.realtimeBlanksData.blanks.push(blankData);
    range.insertNode(span);
    // Ajouter un espace après le blank
    const space = document.createTextNode(this.spaceCharacter);
    span.after(space);
    // Positionner le curseur après l'espace
    range.setStartAfter(space);
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
    this.$nextTick(() => {
      this.ensureEditableSpace();
      // Renumeroter pour mettre à jour l'ID et le numéro
      this.renumberBlanks();
    });
    this.saveSelection();
  }
  /**
   * method to create a html blank
   * @param blankData
   * @private
   */
  createBlankHtml(blankData) {
    const span = document.createElement('span');
    span.className = 'blank-tag';
    span.contentEditable = 'false';
    span.dataset.id = `blank_temp_${++this.blankIdCounter}`;
    span.innerHTML = `<span class="blank-answer-overview">${this.getBlankAnswerOverview(blankData)}</span>
                            ${blankData.type === BlankType.MULTI_SELECT ? '<i class="select-blank-caret-icon icon mdi mdi-chevron-down"></i>' : ''}
                      <span class="blank-delete"><span class="mdi mdi-delete-outline blank-delete-icon"/></span>`;
    return span;
  }
  /**
   * get blank label from blank data
   * @param blankData
   */
  getBlankAnswerOverview(blankData) {
    if (!blankData?.responses?.length) {
      return '';
    }
    if (blankData.type === BlankType.TEXT) {
      return blankData.responses.map(response => response.label).join('; ');
    } else {
      return this.getMultiselectBlankAnswerOverview(blankData);
    }
  }
  getMultiselectBlankAnswerOverview(blankData) {
    const blankResponse = blankData.responses.find(response => response.correctAnswer);
    if (blankResponse) {
      const answerImagePath = quizUtils.getAnswerImagePath(blankResponse.image, true);
      if (answerImagePath) {
        return `<img class="blank-image" src="${answerImagePath}" />`;
      }
      return blankResponse.label || '';
    }
    return '';
  }
  /**
   * S'assure qu'il y a toujours des espaces éditables dans l'éditeur
   */
  ensureEditableSpace() {
    const editor = this.$refs.editorRef;
    if (!editor) return;
    // Toujours avoir un espace au début si le premier élément est un blank
    const firstChild = editor.firstChild;
    if (!firstChild || firstChild.nodeType === Node.ELEMENT_NODE && firstChild.classList?.contains('blank-tag')) {
      const space = document.createTextNode(this.zeroWidthSpaceChar); // Zero-width space
      editor.insertBefore(space, firstChild);
    }
    // Si le premier element de l'éditeur est un br, le remplacer par un zeroWidthSpaceChar
    if (firstChild?.nodeName === 'BR' || firstChild?.textContent === '') {
      firstChild.replaceWith(document.createTextNode(this.zeroWidthSpaceChar));
    }
    // S'assurer qu'il y a un espace après chaque tag
    const tags = editor.querySelectorAll('.blank-tag');
    tags.forEach(tag => {
      // Vérifier l'espace après le tag
      const nextSibling = tag.nextSibling;
      if (!nextSibling || nextSibling.nodeType !== Node.TEXT_NODE) {
        const space = document.createTextNode(this.spaceCharacter);
        tag.after(space);
      }
      // Vérifier si deux tags sont côte à côte (ajouter un espace entre eux)
      const previousSibling = tag.previousSibling;
      if (previousSibling && previousSibling.nodeType === Node.ELEMENT_NODE && previousSibling.classList?.contains('blank-tag')) {
        const space = document.createTextNode(this.spaceCharacter);
        tag.parentNode?.insertBefore(space, tag);
      }
    });
    // S'assurer qu'il y a toujours quelque chose après le dernier élément
    const lastChild = editor.lastChild;
    if (lastChild && lastChild.nodeType === Node.ELEMENT_NODE && lastChild.classList?.contains('blank-tag')) {
      const space = document.createTextNode(this.spaceCharacter);
      editor.appendChild(space);
    }
    // Si l'éditeur est complètement vide, ajouter un espace
    if (!editor.childNodes.length) {
      const space = document.createTextNode(this.spaceCharacter);
      editor.appendChild(space);
    }
  }
  /**
   * Émet le contenu formaté avec les blanks remplacés par [?n]
   */
  emitFormattedContent(isBlankSettingUpdate) {
    const editor = this.$refs.editorRef;
    if (!editor) return;
    // Cloner le contenu pour ne pas modifier l'original
    const clone = editor.cloneNode(true);
    // Remplacer chaque blank par [?n]
    const tags = clone.querySelectorAll('.blank-tag');
    tags.forEach((tag, index) => {
      const placeholder = document.createTextNode(`[?${index + 1}]`);
      tag.replaceWith(placeholder);
    });
    // Remplacer les <br> par des nœuds texte "\n"
    clone.querySelectorAll('br').forEach(br => {
      br.replaceWith(document.createTextNode('\n'));
    });
    // Obtenir le texte final
    const formattedText = clone.textContent || '';
    // Nettoyer les espaces zero-width
    const cleanedText = formattedText.replace(new RegExp(this.zeroWidthSpaceChar, 'g'), '').trim();
    if (cleanedText !== this.realtimeBlanksData.text || isBlankSettingUpdate) {
      this.realtimeBlanksData.text = cleanedText;
      const dataToSave = structuredClone(this.realtimeBlanksData);
      dataToSave.blanks?.forEach(blank => delete blank.htmlId);
      this.$emit('contentChange', dataToSave);
    }
  }
  /**
   * On blank settings update from modal
   * @param blankData
   */
  onBlankSettingsUpdate(blankData) {
    if (blankData.position === -1) {
      this.addBlankAtCursor(blankData);
    } else {
      this.realtimeBlanksData.blanks.forEach(blank => {
        if (blank.htmlId === blankData.htmlId) {
          blank.responses = blankData.responses;
          this.renumberBlanks();
        }
      });
    }
    setTimeout(() => this.emitFormattedContent(true), 100);
  }
  /**
   * on blank as text dialog close
   */
  onBlankAsTextSettingsDialogClose() {
    this.displayBlankAsTextSettingsDialog = false;
    this.activeBlank = null;
  }
  /**
   * on blank as dropdown dialog close
   */
  onBlankAsDropdownSettingsDialogClose() {
    this.displayBlankAsDropdownSettingsDialog = false;
    this.activeBlank = null;
  }
  /**
   * trigger blank edit dialog
   * @param blank
   */
  triggerBlankEdit(blank) {
    this.activeBlank = blank;
    if (blank.type === BlankType.TEXT) {
      this.displayBlankAsTextSettingsDialog = true;
    } else if (blank.type === BlankType.MULTI_SELECT) {
      this.displayBlankAsDropdownSettingsDialog = true;
    }
  }
  /**
   * on blank delete click
   * @param blankToRemove
   */
  deleteBlank(blankToRemove) {
    this.activeBlank = blankToRemove;
    this.displayBlankDeletionDialog = true;
  }
  confirmBlankDeletion() {
    const editor = this.$refs.editorRef;
    if (!editor) return;
    const blankTag = Array.from(editor.querySelectorAll('.blank-tag')).find(tag => this.activeBlank?.htmlId === tag.dataset.id);
    if (blankTag) {
      blankTag.remove();
      this.realtimeBlanksData.blanks = this.realtimeBlanksData.blanks.filter(blank => blank !== this.activeBlank);
      this.$nextTick(() => {
        this.renumberBlanks();
        this.ensureEditableSpace();
      });
    }
    this.displayBlankDeletionDialog = false;
    this.activeBlank = null;
    setTimeout(() => this.emitFormattedContent(true), 100);
  }
  cancelBlankDeletion() {
    this.displayBlankDeletionDialog = false;
    this.activeBlank = null;
  }
};
__decorate([Prop({
  default: {
    text: '',
    blanks: []
  }
})], BlanksInput.prototype, "blanksData", void 0);
__decorate([Watch('blanksData')], BlanksInput.prototype, "blanksDataSet", null);
BlanksInput = __decorate([Component({
  components: {
    BlankAsTextSettingsDialog,
    BlankAsDropdownSettingsDialog,
    ConfirmDialog
  },
  emits: ['contentChange']
})], BlanksInput);
export default BlanksInput;